import { Button } from 'antd'
import { CSSProperties, useState } from 'react'
import { LinkifiedText } from '../linkifiedText'

type DescriptionCellProps = {
  text: string
  style?: CSSProperties
}

const WORD_LIMIT = 12

const getPreview = (text: string): { text: string; isTruncated: boolean } => {
  const words = text.match(/\S+/g) ?? []

  return {
    text:
      words.length > WORD_LIMIT
        ? `${words.slice(0, WORD_LIMIT).join(' ')}…`
        : text,
    isTruncated: words.length > WORD_LIMIT,
  }
}

export const DescriptionCell = ({ text, style }: DescriptionCellProps) => {
  const [expanded, setExpanded] = useState(false)
  const preview = getPreview(text)

  return (
    <span style={{ display: 'block', minWidth: 0, ...style }}>
      <LinkifiedText text={expanded ? text : preview.text} />
      {preview.isTruncated && (
        <Button
          type="link"
          size="small"
          style={{ height: 'auto', padding: 0 }}
          onClick={() => setExpanded((value) => !value)}
        >
          {expanded ? 'Свернуть' : 'Показать ещё'}
        </Button>
      )}
    </span>
  )
}
